import React, { useState, useEffect, useRef } from 'react';
import DialogActions from '@mui/material/DialogActions';
import { MenuItem, Checkbox, ListItemText, TextField, IconButton, Stack } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import axios from '../../../../utils/fvAxios';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import _ from "lodash";
import { ToastContainer, toast } from 'react-toastify';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CloseIcon from '@mui/icons-material/Close';

export default function EmailPage({ DialogClose, DialogOpen, Selected, ClientId, Clear }) {
    const menuListRef = useRef(null);
    const handleUndo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.undo();
    };

    const handleRedo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.redo();
    };
    const quillRef = React.createRef();
    const handleMenuOpen = () => {
        scrollToTopOfOtions();
    };
    const scrollToTopOfOtions = () => {
        setTimeout(() => {
            if (menuListRef.current) {
                const children = menuListRef.current.children;
                if (children.length >= 2) {
                    const secondLastOption = children[children.length - 2];
                    if (secondLastOption) {
                        secondLastOption.scrollTop = 0;
                    }
                }
            }
        }, 5);
    };

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };
    const [CCandBCCInfo, setCCandBCCInfo] = useState([]);
    const [CCID, setCCID] = useState([]);
    const [BCCID, setBCCID] = useState([]);


    const [To, setTo] = useState("");
    const [Cc, setCc] = useState("");
    const [BCc, setBCc] = useState("");
    const [Body, setBody] = useState("");
    const [Superuser, setSuperuser] = useState("");
    const [VendorEmails, setVendorEmails] = useState("");
    const [Useid, setUseid] = useState("");
    const [Ccerror, setCcError] = useState("");
    const [BCcerror, setBCcError] = useState("");


    const [spinner, setSpinner] = React.useState(false);

    useEffect(() => {
        Details();
    }, []);

    const SpinnerClose = () => {
        setSpinner(false);
    };

    const PQID = Selected[0]?.prequalificationId;
    const PQIDS = Selected?.map((r) => r?.prequalificationId);
    const VENDORIDS = Selected?.map((r) => r?.vendorId);


    async function Details() {
        setSpinner(!spinner);
        const res = await axios.get("MyAccount/GetCCAndBCCListForEmailVendor?orgID=" + ClientId + "&PqId=" + PQID);
        setCCandBCCInfo(res?.data?.data);

        const resp = await axios.get("Organization/GetSuperuser?orgId=" + ClientId);
        setSuperuser(resp?.data?.data?.email);
        setUseid(resp?.data?.data?.userId);

        const responce = await axios.get("MyAccount/GetPQVendorEmailsByPqIDs?PqIds=" + PQIDS);
        setVendorEmails(responce?.data?.data);
        setSpinner(false);
    }

    const [open, setOpen] = React.useState(false);
    const DialogOpenClick = () => {
        setTo("info@firstverify.com");
        setCc(CCID == "" ? Superuser : CCID + "," + Superuser);
        setBCc(BCCID == "" ? VendorEmails : BCCID + "," + VendorEmails);
        setOpen(true);
        setCcError("");
        setBCcError("");
    };
    const DialogCloseClick = () => {
        setOpen(false);
    };

    const ChangeBody = (data) => {
        setBody(data);
    }
    const ChangeCc = (e) => {
        let regex = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
        let result = e.target.value.split(",");
        result.forEach((em) => {
            if (regex.test(em) == true) {
                setCcError("");
                setCc(e.target.value);
            } else if (em == "") {
                setCcError("");
                setCc(e.target.value);
            } else {
                setCcError("Please check CC email");
                setCc(e.target.value);
            }

        });

    }
    const ChangeBCc = (e) => {
        let regex = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
        let result = e.target.value.split(",");
        result.forEach((em) => {
            if (regex.test(em) == true) {
                setBCcError("");
                setBCc(e.target.value);
            } else if (em == "") {
                setBCcError("");
                setBCc(e.target.value);
            } else {
                setBCcError("Please check BCC email");
                setBCc(e.target.value);
            }

        });

    }

    const [DisSendEmail, setDisSendEmail] = React.useState(false);
    const SendEmail = async () => {
        setDisSendEmail(true);
        if (Ccerror == "" && BCcerror == "") {
            const data = {
                "toAddress": To,
                "ccAddress": Cc,
                "bccAddress": BCc,
                "body": Body,
                "vendorIds": _.toString(VENDORIDS),
                "clientId": ClientId,
                "pqIds": _.toString(PQIDS),
                "userId": Useid,
                "emailStatus": true,
                "bccSendEmailToVendorContacts": true
            }
            const resp = await axios.post("Vendor/SendEmailToVendorUsers", data);
            if (resp?.data?.responseCode == 100) {
                toastNotify(resp?.data?.data, true);
                DialogCloseClick();
                DialogClose();
                Clear();
                setDisSendEmail(false);
            } else {
                toastNotify(resp?.data?.responseMessage, false);
                setDisSendEmail(false);
                DialogOpen()
            }
        }
        else {
            toastNotify("Please enter mandatory fields", false);
            DialogOpen()
            setDisSendEmail(false);
        }

    }

    const formats = [
        "strike",
        "size",
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'background',
        'list',
        'align',
        // 'link',
        // 'image',
        'color',
        'indent',
        'clean',
        'blockquote', 'script'

    ];

    const modules = {
        toolbar: [
            ['undo', 'redo'],
            [{ 'size': [] }],
            [{ 'font': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],

            ['clean'],

            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
        ],
    };

    return (
        <>
            {/* <ToastContainer /> */}
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog fullScreen={fullScreen} open={open} onClose={DialogCloseClick}>
                <DialogContent sx={{ padding: "48px 48px" }} >
                    <span onClick={DialogCloseClick} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span style={{ fontSize: "larger" }} >Email Vendor</span>
                    </DialogTitle>

                    <DialogActions >
                        <div>
                            <DialogActions >
                                <div>
                                    <div className='mt-3' >
                                        <span style={{ color: "#3E4A62" }}>To <span style={{ color: "red" }}>*</span></span>
                                        <br />

                                        <TextField
                                            disabled
                                            placeholder="TO"
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                backgroundColor: "#fff",
                                                marginTop: "2px",
                                                marginBottom: "5px",
                                            }}

                                            variant="outlined"
                                            size="small"
                                            value={To || ""}
                                            onChange={(e) => setTo(e.target.value)}

                                        />
                                    </div>

                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}> CC </span>
                                        <br />

                                        <TextField

                                            placeholder="CC"
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                backgroundColor: "#fff",
                                                marginTop: "2px",
                                                marginBottom: "5px",
                                            }}

                                            variant="outlined"
                                            size="small"
                                            value={Cc || ""}
                                            onChange={(e) => ChangeCc(e)}

                                        />

                                    </div>
                                    <p style={{ color: "red" }}>{Ccerror}</p>
                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}> BCC </span>
                                        <br />

                                        <TextField

                                            placeholder="BCC"
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                backgroundColor: "#fff",
                                                marginTop: "2px",
                                                marginBottom: "5px",
                                            }}

                                            variant="outlined"
                                            size="small"
                                            value={BCc || ""}
                                            onChange={(e) => ChangeBCc(e)}

                                        />

                                    </div>
                                    <p style={{ color: "red" }}>{BCcerror}</p>
                                    <div style={{ width: "500px" }}>
                                        {/* <CKEditor
                                            editor={ClassicEditor}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                ChangeBody(data);
                                            
                                            }}
                                        /> */}
                                        <div>
                                            <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px" }}>
                                                <UndoIcon />
                                            </IconButton>
                                            <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                                                <RedoIcon />
                                            </IconButton>

                                            <ReactQuill
                                                ref={quillRef}
                                                theme="snow"
                                                modules={modules}
                                                formats={formats}
                                                value={Body}
                                                onChange={setBody}
                                            />
                                        </div>
                                    </div>
                                    <DialogActions >
                                        <div className="login-help__buttonContainer mt-4">
                                            <Button variant="contained" className="login-help-button-cancel mx-2" onClick={DialogCloseClick}>Cancel</Button>
                                            <Button disabled={DisSendEmail} variant="contained" className="login-button-request mx-2" onClick={SendEmail}> send</Button>
                                        </div>

                                    </DialogActions>
                                </div >
                            </DialogActions>
                        </div>
                    </DialogActions>
                </DialogContent>

            </Dialog>

            <DialogContent sx={{ padding: "48px 48px" }}>
                <span onClick={DialogClose} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                <DialogTitle
                    sx={{
                        textAlign: "center",
                        fontWeight: 500,
                        fontSize: 20,
                    }}
                >
                    <span style={{ fontSize: "larger" }} >Select Recipients</span>
                </DialogTitle>

                <DialogActions >
                    <div>
                        <div className='mt-3' >
                            <span style={{ color: "#3E4A62" }}>Send via CC to </span>
                            <br />
                            <Select
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{ width: "320px", overflow: "hidden" }}
                                name="Site Safety Representive"
                                value={CCID || []}
                                MenuProps={{
                                    ref: menuListRef,
                                    PaperProps: MenuProps.PaperProps,
                                }
                                }
                                renderValue={(selected) =>
                                    selected
                                        .map((key) => CCandBCCInfo?.find((doc) => doc?.key === key)?.value)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setCCID(e.target.value)}
                            >
                                <MenuItem key="Select All">
                                    <Checkbox
                                        id="select-all-checkbox"
                                        indeterminate={
                                            CCID?.length > 0 && CCID?.length < CCandBCCInfo?.length
                                        }
                                        checked={CCID?.length === CCandBCCInfo?.length}
                                        onChange={(event) => {
                                            if (event?.target?.checked) {
                                                setCCID(CCandBCCInfo?.map((doc) => doc?.key));
                                                scrollToTopOfOtions();
                                            } else {
                                                setCCID([]);
                                            }
                                        }}
                                    />
                                    <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                        Select All
                                    </label>
                                    {/* <ListItemText primary="Select All" /> */}
                                </MenuItem>
                                {CCandBCCInfo?.map((r) => (
                                    <MenuItem key={r?.key} value={r?.key}>
                                        <Checkbox checked={CCID?.indexOf(r?.key) > -1} />
                                        <ListItemText primary={r?.value} />

                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className='mt-3'>
                            <span style={{ color: "#3E4A62" }}>Send via BCC to  </span>
                            <br />

                            <Select
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{ width: "320px", overflow: "hidden" }}
                                name="Site Safety Representive"
                                value={BCCID || []}
                                MenuProps={{
                                    ref: menuListRef,
                                    PaperProps: MenuProps.PaperProps,
                                }
                                }
                                renderValue={(selected) =>
                                    selected
                                        .map((key) => CCandBCCInfo?.find((doc) => doc?.key === key)?.value)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setBCCID(e.target.value)}
                            >
                                <MenuItem key="Select All">
                                    <Checkbox
                                        id="select-all-checkbox"
                                        indeterminate={
                                            BCCID?.length > 0 && BCCID?.length < CCandBCCInfo?.length
                                        }
                                        checked={BCCID?.length === CCandBCCInfo?.length}
                                        onChange={(event) => {
                                            if (event?.target?.checked) {
                                                setBCCID(CCandBCCInfo?.map((doc) => doc?.key));
                                                scrollToTopOfOtions();
                                            } else {
                                                setBCCID([]);
                                            }
                                        }}
                                    />
                                    <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                        Select All
                                    </label>
                                    {/* <ListItemText primary="Select All" /> */}
                                </MenuItem>
                                {CCandBCCInfo?.map((r) => (
                                    <MenuItem key={r?.key} value={r?.key}>
                                        <Checkbox checked={BCCID?.indexOf(r?.key) > -1} />
                                        <ListItemText primary={r?.value} />

                                    </MenuItem>
                                ))}
                            </Select>

                        </div>
                        <DialogActions >
                            <div className="login-help__buttonContainer mt-4">
                                <Button variant="contained" className="login-help-button-cancel mx-2" onClick={DialogClose}>Cancel</Button>
                                <Button variant="contained" className="login-button-request mx-2" onClick={DialogOpenClick}> Next</Button>
                            </div>

                        </DialogActions>
                    </div >
                </DialogActions>
            </DialogContent >
        </>
    )
}
